module.exports = __webpack_public_path__ + "img/pcb_pic.8a8fa157.png";